import { CommonPopup } from '../commonPopup/commonPopup.component';

export class BroadcastingLockPopup extends CommonPopup {
  static _template() {
    return {
      ...super._template(),
      title: 'layout.locks.live.unavailableNotAiring',
    };
  }
}
